export const MISSING_DATA_DESCRIPTIONS = {
  configuration: {
    companies: "Allgemeine Angaben zu Unternehmen:",
    connections: "Daten zu Netzverknüpfungspunkten:"
  },
  meteringConcept: {
    meterMeteringConcept: "Messkonzept relevante Daten für Zähler: "
  },
  regulatory: {
    generalGenerators: "Allgemeine Angaben zu Erzeugungsanlagen:",
    regulatoryGenerators: "Regulatorische Angaben zu Erzeugungsanlagen:",
    regulatoryData: "Regulatorische Angaben zu Unternehmen:",
    regulatoryConsumers: "Regulatorische Angaben zu Verbraucher:",
    taxData: "Steuerrechtliche Daten zu Unternehmen:",
    invoiceData: "Angaben zur Stromlieferung und Abrechnung zu Unternehmen:",
    eeg: "Angaben zu EEG-Anlagen:",
    kwk: "Angaben zu KWK-Anlagen:",
    generationShares: "Angaben zu Erzeugungsanteilen:"
  },
  vollmacht: {
    meters:
      "Für die/den aufgeführten Zähler benötigen wir noch eine eindeutige Kennung, um die Messdaten richtig zuordnen zu können. \
        Zähler, für welche wir die Messdaten von einem Messstellenbetreiber erhalten sollen, benötigen in jedem Fall einen Messlokations- (Melo – 33-stellig, beginnend mit DE…) oder eine Marktlokationsnummer (Malo – 11-stellig). \
        Andernfalls kann die Zuordnung über die Zählernummer vom Hersteller erfolgen.",
    marketLocations: "Daten für Marktlokationen:",
    meteringLocations: "Daten für Messlokationen:"
  },
  invoice: {
    delivery: "Stromkennzeichnung für Lieferungen:",
    site: "Daten für Liegenschaften:"
  },
  historischeMessdaten: {
    meters: "Daten für das Meldejahr der Zähler:"
  },
  generator: {
    contract: "Zuweisung von Erzeugern zu Verträgen:"
  }
};
